import api from '@/lib/api';
import type { AdminErrorGroup, AdminErrorOccurrence } from '@/types/admin';

export async function fetchErrors(): Promise<AdminErrorGroup[]> {
  const { data } = await api.get('/admin/errors');
  const body = data as { data?: AdminErrorGroup[] } | AdminErrorGroup[];
  return Array.isArray(body) ? body : body.data ?? [];
}

export async function fetchErrorOccurrences(signature: string): Promise<AdminErrorOccurrence[]> {
  const { data } = await api.get(`/admin/errors/${encodeURIComponent(signature)}`);
  const body = data as { data?: AdminErrorOccurrence[] } | AdminErrorOccurrence[];
  return Array.isArray(body) ? body : body.data ?? [];
}
